export default __webpack_public_path__ + "static/media/mail_black.1f98df04.svg";